import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import moment from "moment"
import {
  GetAllNonWorkingHours,
  deleteNonWorkinghours,
} from "store/CalculateIncentive/action"
import { setIsMobile } from "store/actions"
import { getTeamLookup } from "store/createTeam/action"
// components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "./Table/Table"
import MobileView from "./MobileView"
import DeleteModal from "components/Common/DeleteModal"
import IncentiveForm from "./IncentiveForm"
import { taskTotalHoursConversion } from "helpers/util"

const Index = () => {
  const dispatch = useDispatch()
  // use selector
  const {
    isMobile,
    calculateincentiveData,
    teamList,
    companySetting,
    useraccesSetting,
  } = useSelector(state => ({
    isMobile: state.teams.isMobile,
    calculateincentiveData:
      state?.Caculateincentive?.getallnonworkinghoursSuccess,
    teamList: state?.createteam?.createTeamLookupList,
    companySetting: state?.Login?.userDetails?.data,
    useraccesSetting: state?.Login?.usersDetails?.data,
  }))
  
  const calculateincentiveList =
    calculateincentiveData?.nonWorkingHoursLst?.map(el => ({
      ...el,
      less45days:
        new Date(el.startDate) <
          new Date(new Date().setDate(new Date().getDate() - 45)) ==
        true
          ? "Less than 45Days"
          : "greater than 45days",
    }))

  const AccessAdmin = useraccesSetting?.accessgroupname
  const [handleAccordion, sethandleAccordion] = useState(false)
  
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteworkingHoursid, setDeleteworkingHoursid] = useState(false)
  // edit by modal open
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRow, setselectedRow] = useState({})

  // start and end date
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [isSorting, setIsSorting] = useState(false)

  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    sortKey: "UserName",
    sortValue: "asc",
  })

  useEffect(() => {
    dispatch(GetAllNonWorkingHours(pagination))
    dispatch(getTeamLookup())
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //delete incentive
  const onHandleFilterBtnClicked = () => {
    dispatch(GetAllNonWorkingHours(pagination))
  }

  const onClickDelete = id => {
    setDeleteworkingHoursid(id)
    setDeleteModal(true)
  }

  const handleDeleteincentive = () => {
    if (deleteworkingHoursid.id) {
      dispatch(deleteNonWorkinghours(deleteworkingHoursid.id))
      setDeleteModal(false)
      onHandleFilterBtnClicked()
    }
  }
  useEffect(() => {
    onHandleFilterBtnClicked()
  }, [pagination])

  // edit and toggle function
  // toggel Function
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  // Handle Row Modal
  const rowEdit = item => {
    setselectedRow(item)
    setIsEdit(true)
    toggle()
  }

  //HandleClick Function new
  const handleIncentiveClicks = () => {
    setselectedRow({})
    setIsEdit(false)
    toggle()
  }

  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  // pagination concept
  const handlePageChange = page => {
    setPagination(prev => ({ ...prev, pageNumber: page }))
    setIsSorting(false)
  }

  const handlePageSizeChange = size => {
    setPagination(prev => ({ ...prev, pageSize: size }))
    setIsSorting(false)
  }

  const handleSortChange = accessor => {
    setPagination(prev => ({
      ...prev,
      sortKey: accessor?.sortkeys,
      sortValue: accessor?.sortDirection === "asc" ? "desc" : "asc",
      pageNumber: pagination.pageNumber,
    }))
    setIsSorting(!isSorting)
  }

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Start Date",
        accessor: "startDate",
        disableFilters: true,
        sort: true,
        sortDirection:
          pagination?.sortKey === "UserName" ? pagination?.sortValue : "none",
        sortkeys: "UserName",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          let formattedDate = moment
            .parseZone(cellProps?.value)
            .format("YYYY-MM-DD")
          return formattedDate
        },
      },
      {
        Header: "End Date",
        accessor: "endDate",
        sortDirection:
          pagination?.sortKey === "UserName" ? pagination?.sortValue : "none",
        disableFilters: true,
        sort: true,
        sortkeys: "UserName",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          let formattedDate = moment
            .parseZone(cellProps?.value)
            .format("YYYY-MM-DD")
          return formattedDate
        },
      },

      {
        Header: "EmpName",
        accessor: "userName",
        sortDirection:
          pagination?.sortKey === "UserName" ? pagination?.sortValue : "none",
        disableFilters: true,
        sortkeys: "UserName",
        sort: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },

      {
        Header: "Project",
        accessor: "subcategoryName",
        sortDirection:
          pagination?.sortKey === "SubcategoryName"
            ? pagination?.sortValue
            : "none",
        disableFilters: true,
        sortkeys: "SubcategoryName",
        sort: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Maximum Hours",
        accessor: "maximumHours",
        sortDirection:
          pagination?.sortKey === "UserName" ? pagination?.sortValue : "none",
        sortkeys: "UserName",
        disableFilters: true,
        sort: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            <>{taskTotalHoursConversion(cellProps.row.original.maximumHours)}</>
          )
        },
      },
      {
        Header: "Comments",
        accessor: "comments",
        sortDirection:
          pagination?.sortKey === "Comments" ? pagination?.sortValue : "none",
        sortkeys: "Comments",
        disableFilters: true,
        sort: true,
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Action",
        accessor: "less45days",
        disableFilters: true,
        sort: false,
        hidden: AccessAdmin == "Admin" ? false : true,
        Cell: cellProps => {
          return (
            <div
              role="buttton "
              style={{
                cursor: "Pointer",
                // textAlign: !isMobile ? "center" : "start",
              }}
            >
              {cellProps.row.original?.less45days == "greater than 45days" ? (
                <UncontrolledDropdown>
                  <DropdownToggle href="#" className="card-drop" tag="i">
                    <i className="mdi mdi-dots-vertical font-size-18" />
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      href="#"
                      onClick={() => rowEdit(cellProps.row.original)}
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      href="#"
                      onClick={() => onClickDelete(cellProps.row.original)}
                    >
                      Delete
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                cellProps.row.original.less45days
              )}
            </div>
          )
        },
      },
    ]
    return result
  }, [isMobile, AccessAdmin, pagination])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteincentive}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Calculate Incentive"}
            breadcrumbItem={"Calculate Incentive"}
          />

          <Card>
            <CardBody>
              <Col md="12">
                <div className="text-sm-end my-2 ">
                  <Button
                    type="button"
                    color="primary"
                    className="btn-rounded mb-2 me-2"
                    onClick={() => handleIncentiveClicks()}
                  >
                    <i className="mdi mdi-plus me-1" />
                    Add Incentive
                  </Button>
                </div>
              </Col>
              <Row>
                <Col xs="12">
                  <div className="p-0">
                    {!isMobile ? (
                      <>
                        <div className="table-mobileView">
                          <TableContainer
                            columns={columns}
                            data={calculateincentiveList || []}
                            isMobile={isMobile}
                            // pagination concept
                            isSorting={isSorting}
                            customPageSize={pagination?.pageSize}
                            pageNumber={pagination?.pageNumber}
                            totalCount={calculateincentiveData?.count || 0}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            onHeaderClick={handleSortChange}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {calculateincentiveList?.map((item, index) => {
                          return (
                            <MobileView
                              key={item.userName}
                              keyId={index}
                              data={item || []}
                              sethandleAccordion={sethandleAccordion}
                              handleAccordion={handleAccordion}
                              rowEdit={rowEdit}
                              onClickDelete={onClickDelete}
                              AccessAdmin={AccessAdmin}
                            />
                          )
                        })}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              {/* // modal form non working hourstracking */}

              <Modal isOpen={modal} toggle={toggle} size="md">
                <ModalHeader toggle={toggle} tag="h4">
                  {!!isEdit ? "Edit Incentive" : "New Incentive"}
                </ModalHeader>
                <ModalBody>
                  <IncentiveForm
                    setStartDate={setStartDate}
                    startDate={startDate}
                    setEndDate={setEndDate}
                    endDate={endDate}
                    selectedRow={selectedRow}
                    handleCancel={handleCancel}
                    toggle={toggle}
                    isEdit={isEdit}
                    MainCategory={teamList?.categoryLookup}
                    teams={teamList?.subCategoryLookup}
                    companySetting={companySetting}
                  />
                </ModalBody>
              </Modal>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
Index.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Index
